module.exports = __webpack_public_path__ + "static/media/LU.6300ba6f.png";